import MPagination from './MPagination';

export default MPagination;
